import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import categoriesReducer from './slices/categoriesSlice';
import coloringReducer from './slices/coloringSlice';
import canvasReducer from './slices/canvasSlice';
import { imagesApi } from './api/imagesApi';
import { CategoriesState, ColoringState } from '../types';
import { CanvasState } from './slices/canvasSlice';

export const store = configureStore({
  reducer: {
    categories: categoriesReducer,
    coloring: coloringReducer,
    canvas: canvasReducer,
    [imagesApi.reducerPath]: imagesApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(imagesApi.middleware),
});

export type RootState = {
  categories: CategoriesState;
  coloring: ColoringState;
  canvas: CanvasState;
} & {
  [imagesApi.reducerPath]: ReturnType<typeof imagesApi.reducer>;
};

export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>; 